<template>
  <div class="container-370 pt-20">
    <div class="main-title mt-20 mb-20 text-center">予約の日時は？（必須）</div>
    <div class="calendar-content ">
      <template v-if="!meeting">
        <div v-if="$auth.user().type === USER_TYPE_PHARMACIST">
          <CalendarOnlineMeeting @dateChanged="dateChanged"
            :auto-set-today="!pharmacy ? true : false"
            :pharmacy="pharmacy"
            @closeModal="closeModal"
          ></CalendarOnlineMeeting>
        </div>
        <div v-else>
          <Calendar @dateChanged="dateChanged"
            :auto-set-today="!pharmacy ? true : false"
            :pharmacy="pharmacy"
            @closeModal="closeModal"
          ></Calendar>
        </div>
      </template>
      <template v-else>
        <div v-if="$auth.user().type === USER_TYPE_PHARMACIST">
          <CalendarOnlineMeeting @dateChanged="dateChanged" :auto-set-today="!pharmacy ? true : false" :pharmacy="pharmacy" :meeting="meeting" @closeModal="closeModal"></CalendarOnlineMeeting>
        </div>
        <div v-else>
          <Calendar @dateChanged="dateChanged" :auto-set-today="!pharmacy ? true : false" :pharmacy="pharmacy" @closeModal="closeModal" :meeting="meeting"></Calendar>
        </div>
      </template>
    </div>

    <div class="time-meeting-selected text-center p-15 mt-20" v-if="pharmacy && selectedTime">
      {{formatSelectedTime(selectedTime.start)}} ~ {{formatSelectedTime(selectedTime.end)}}
    </div>

    <div v-if="!pharmacy && dateSelected" class="selected-time">
      <div v-if="statusDateSelected === 'future'">
        <el-time-select placeholder="開始日時" :picker-options="pickerOptionsStartTime" @change="changeOnlineMeetingTime" v-model="onlineSelectedTime.start"/>
        <el-time-select placeholder="終了日時" :picker-options="pickerOptionsEndTime" @change="changeOnlineMeetingTime" id="select-end-time" v-model="onlineSelectedTime.end"/>
      </div>
      <div v-else-if="statusDateSelected === 'past'">
        <el-time-select :picker-options="{ minTime: '23:59' }" placeholder="開始日時" @change="changeOnlineMeetingTime" v-model="onlineSelectedTime.start"/>
        <el-time-select :picker-options="{ minTime: '23:59' }" placeholder="終了日時" @change="changeOnlineMeetingTime" id="select-end-time" v-model="onlineSelectedTime.end"/>
      </div>
      <div v-else>
        <el-time-select placeholder="開始日時" @change="changeOnlineMeetingTime" v-model="onlineSelectedTime.start" :picker-options="pickerOptionsStartTime"/>
        <el-time-select placeholder="終了日時" @change="changeOnlineMeetingTime" id="select-end-time" v-model="onlineSelectedTime.end" :picker-options="pickerOptionsEndTime"/>
      </div>
    </div>

    <div class="modal-overlay" v-if="showMeetingTimePicker" @click="showMeetingTimePicker = false">
      <div class="modal time-picker-modal" @click.stop="" v-loading="timesList === null">
        <div class="modal-header p-16 text-center">
          <span>
            {{dateSelected.year()}}年 {{dateSelected.month() + 1}}月{{dateSelected.date()}}日（{{dateSelected.day() | dayOfWeekLabel}}）
          </span>
        </div>
        <div class="modal-body">
          <ul v-if="timesList && timesList.length > 0">
            <li class="pt-20 pb-20" v-for="item in timesList" :key="item.id"
              v-if="item.available">
              {{item.start.format('HH:mm')}}〜{{item.end.format('HH:mm')}}
              <button v-if="checkStatusButton(item) === 'disabled'" type="button" disabled class="button success small disabled">予約申請</button>
              <button v-else-if="checkStatusButton(item) === 'available'" type="button" class="button success small" @click="selectTime(item)">予約申請</button>
              <span v-else class="button warning small" style="cursor: not-allowed">予約済み</span>
            </li>
          </ul>
          <p v-else style="line-height: 45px;text-align: center;">
            予約できる日程がありません
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import moment from 'moment'
import PharmaciesApi from '@/api/pharmacies'
import {apiErrorDialog, zeroPadNumber} from '@/helpers'
import Calendar from '@/components/Calendar'
import CalendarOnlineMeeting from '@/components/CalendarOnlineMeeting'

import {USER_TYPE_PHARMACIST} from '@/const'

export default {
  props: {
    meeting: {type: Object, require: false},
    pharmacy: {type: Object, require: false},
    oldPharmacy: {type: Object, require: false},
    localMeeting: {type: Object, require: false}
  },
  data () {
    return {
      USER_TYPE_PHARMACIST,
      dateSelected: null,
      showMeetingTimePicker: false,
      timesList: null,
      selectedTime: null,
      onlineSelectedTime: {start: null, end: null},
      statusDateSelected: null
    }
  },
  components: {Calendar, CalendarOnlineMeeting},
  computed: {
    pickerOptionsStartTime: function () {
      if (this.statusDateSelected === 'now') {
        let minTime = null
        if (moment().minutes() < 15) {
          minTime = `${moment().hour()}:14`
        } else if (moment().minutes() < 30) {
          minTime = `${moment().hour()}:29`
        } else if (moment().minutes() < 45) {
          minTime = `${moment().hour()}:44`
        } else if (moment().minutes() >= 45) {
          minTime = `${moment().hour()}:59`
        }
        if (this.$route.name === 'meetings.edit') {
          minTime = '00:00'
        }
        return {
          minTime: minTime,
          maxTime: `${this.onlineSelectedTime.end ? this.onlineSelectedTime.end : '23:45'}`,
          start: '00:00',
          step: '00:15',
          end: '23:30'
        }
      }
      if (this.statusDateSelected === 'future') {
        return {
          minTime: null,
          maxTime: `${this.onlineSelectedTime.end ? this.onlineSelectedTime.end : '23:45'}`,
          start: '00:00',
          step: '00:15',
          end: '23:30'
        }
      }
    },
    pickerOptionsEndTime: function () {
      if (this.statusDateSelected === 'now') {
        let minTime = null
        if (moment().minutes() < 15) {
          minTime = `${moment().hour()}:29`
        } else if (moment().minutes() < 30) {
          minTime = `${moment().hour()}:44`
        } else if (moment().minutes() < 45) {
          minTime = `${moment().hour()}:59`
        } else if (moment().minutes() >= 45) {
          minTime = `${moment().hour() + 1}:14`
        }
        minTime = `${this.onlineSelectedTime.start}` ? `${this.onlineSelectedTime.start}` : minTime
        if (this.$route.name === 'meetings.edit') {
          const cond = moment(`${this.dateSelected.year()}-${this.dateSelected.month() + 1}-${this.dateSelected.date()} ${this.onlineSelectedTime.start}:00`).isBefore(moment())
          if (cond) {
            minTime = moment().format('HH:mm')
          } else {
            minTime = `${this.onlineSelectedTime.start}`
          }
        }
        return {
          minTime: minTime,
          start: '00:15',
          step: '00:15',
          end: '23:45'
        }
      }
      if (this.statusDateSelected === 'future') {
        return {
          minTime: `${this.onlineSelectedTime.start ? this.onlineSelectedTime.start : '00:00'}`,
          start: '00:15',
          step: '00:15',
          end: '23:45'
        }
      }
    }
  },
  methods: {
    zeroPadNumber,
    selectTime (time) {
      this.selectedTime = time
      this.showMeetingTimePicker = false
      this.$emit('input', time)
    },
    formatSelectedTime (timeString) {
      return moment(timeString).format('HH:mm')
    },
    changeOnlineMeetingTime () {
      const start = this.dateSelected.format('Y-MM-DD') + ' ' + this.onlineSelectedTime.start + ':00'
      const end = this.onlineSelectedTime.end ? this.dateSelected.format('Y-MM-DD') + ' ' + this.onlineSelectedTime.end + ':00' : null
      const dayInWeek = moment(this.dateSelected).weekday()
      this.$emit('input', {start: moment(start), end: end ? moment(end) : null, dayInWeek: dayInWeek})
    },
    checkStatusButton (time) {
      if (moment().isAfter(time.end)) return 'disabled'
      if (time.meeting && time.meeting.status === 5) return 'available'
      if (!time.meeting || (time.used && time.meeting.status === 3)) return 'available'
      return 'used'
    },
    async dateChanged (date) {
      this.timesList = null
      this.selectedTime = null
      this.onlineSelectedTime = {start: null, end: null}
      this.dateSelected = date
      this.$emit('input', {start: null, end: null, dayInWeek: moment(this.dateSelected).weekday()})
      if (this.pharmacy) {
        this.showMeetingTimePicker = true
        const start = date.format('Y-MM-DD') + ' 00:00:00'
        const end = date.format('Y-MM-DD') + ' 23:59:59'
        const res = await PharmaciesApi.getCalendar(this.pharmacy.id, {start, end})
          .catch((error) => {
            apiErrorDialog(this, error)
          })
        let timesArr = []
        _.forEach(res.data.data, n => {
          let time = n
          time.start = moment(n.start)
          time.end = moment(n.end)
          timesArr.push(time)
        })
        this.timesList = _.filter(timesArr, n => moment().isBefore(n.end))
      }
      this.checkStatusDate()
    },
    closeModal () {
      this.showMeetingTimePicker = false
    },
    checkStatusDate () {
      const now = moment().format('YYYY-MM-DD 00:00:00')
      const dateSelected = moment(this.dateSelected).format('YYYY-MM-DD 00:00:00')
      if (moment(dateSelected).diff(moment(now)) < 0) this.statusDateSelected = 'past'
      if (moment(dateSelected).diff(moment(now)) > 0) this.statusDateSelected = 'future'
      if (moment(dateSelected).diff(moment(now)) === 0) this.statusDateSelected = 'now'
    }
  },
  mounted () {
    if (!this.pharmacy) {
      let minTime = null
      if (moment().minutes() < 15) {
        minTime = `${moment().hour()}:15`
      } else if (moment().minutes() < 30) {
        minTime = `${moment().hour()}:30`
      } else if (moment().minutes() < 45) {
        minTime = `${moment().hour()}:45`
      } else if (moment().minutes() >= 45 && moment().hour() <= 23) {
        minTime = `${moment().hour() + 1}:00`
      }
      this.onlineSelectedTime.start = minTime
    }
    // check if reservation
    if (this.pharmacy && this.meeting) {
      this.selectedTime = this.meeting.time_picked
      this.$emit('input', this.selectedTime)
      if (this.$route.name === 'meetings.edit' && this.meeting.pharmacy.id !== this.oldPharmacy.id) {
        this.selectedTime = null
      }
    }
    // check if online meeting
    if (!this.pharmacy) {
      this.onlineSelectedTime.start = this.meeting ? moment(this.meeting.start_at).format('HH:mm') : ''
      this.onlineSelectedTime.end = this.meeting ? moment(this.meeting.end_at).format('HH:mm') : ''
      this.$emit('input', {
        start: this.meeting ? moment(this.meeting.start_at) : '',
        end: this.meeting ? moment(this.meeting.end_at) : ''
      })
    }
  }
}
</script>

<style scoped>
  .selected-time {
    margin-top: 30px;
    padding: 15px;
    background: #fff;
  }
  .el-date-editor.el-input,
  .el-date-editor.el-input__inner {
    width: 168px;
  }
</style>



// WEBPACK FOOTER //
// src/components/meetings/create/TimePicker.vue